import { RoutingMetadata } from "./types";

/**
 * Get the human-readable display name for the active routing persona.
 */
export function getModeDisplayName(routing: RoutingMetadata): string {
  return routing.persona_name || "Default";
}

/**
 * Get a contextual label describing the routing persona, e.g. "Using CR Review & Analysis".
 * General-chat omits "tools" since it has no specialized toolkits.
 */
export function getRoutingContextLabel(routing: RoutingMetadata): string {
  if (routing.persona_slug === "general-chat") {
    return "Using General Chat";
  }
  return `Using ${getModeDisplayName(routing)}`;
}

/**
 * Get a label for when routing changed between messages, e.g. "Switched to General Chat".
 */
export function getRoutingChangeLabel(routing: RoutingMetadata): string {
  return `Switched to ${getModeDisplayName(routing)}`;
}

/**
 * Build a summary of why this persona was selected.
 */
export function getModeMatchSummary(routing: RoutingMetadata): string {
  const pct = Math.round(routing.confidence * 100);
  return `${routing.reasoning}\nConfidence: ${pct}%`;
}
